import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-banner',
  templateUrl: './header-banner.component.html',
  styleUrls: ['./header-banner.component.css']
})
export class HeaderBannerComponent implements OnInit {
  url:any = '../assets/img/header-promotion2.jpg'
  img:any;
  nombre:any;
  promo:any = 'url("'+this.url+'")';
  constructor() { }

  ngOnInit(): void {
  }

}
